<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab title="الدفاع عن جازية البحث - الدفاع الثاني">
              <app-timeline>
                <app-timeline-item v-for="item in items" :key="item.id" :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '" :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'" />
              </app-timeline>
              <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <form-wizard color="#80b02c" :subtitle="null" :title="null" :finish-button-text="$t('site.finish')"
                :back-button-text="$t('site.back')" :next-button-text="$t('site.next')" @on-complete="formSubmitted"
                :start-index="tab" step-size="sm" ref="wizard">
                <b-card>
                  <!-- attach_master_file -->

                  <!-- <tab-content title=" الإحالة للتدقيق اللغوي والإملائي " :before-change="() => validateStep('referral_for_grammar_and_spelling_check')
                    ">
                    <upload-vue ref="referral_for_grammar_and_spelling_check"
                      datakey="referral_for_grammar_and_spelling_check" :files="referral_for_grammar_and_spelling_check"
                      :master="masterId" />
                  </tab-content> -->
                  <tab-content
                  :title="$t('master.research_readiness_defense')"
                >
                  <online-session-vue v-if="research_readiness_defense"
                    :mediaData="research_readiness_defense.online_session"
                    ref="research_readiness_defense"
                  ></online-session-vue>
                </tab-content>
                  <!-- <tab-content title="إحالة البحث للتأكد من مطابقة المواصفات الفنية"
                    :before-change="() => validateStep('refer_the_search_to_ensure_compliance_with_the_technical_specifications')">
                    <upload-vue ref="refer_the_search_to_ensure_compliance_with_the_technical_specifications"
                      datakey="refer_the_search_to_ensure_compliance_with_the_technical_specifications"
                      :files="refer_the_search_to_ensure_compliance_with_the_technical_specifications"
                      :master="masterId" />
                  </tab-content> -->
                  <!-- <tab-content title="الدفاع عن جاهزية البحث  "
                    :before-change="() => validateStep('research_readiness_defense')">
                    <upload-vue ref="research_readiness_defense" datakey="research_readiness_defense"
                      :files="research_readiness_defense" :master="masterId" />
                  </tab-content> -->
                  <!-- <tab-content title="لجنة تقييم الدفاع عن جاهزية البحث  "
                    :before-change="() => validateStep('research_readiness_defense_evaluation_committee')">
                    <upload-vue ref="research_readiness_defense_evaluation_committee"
                      datakey="research_readiness_defense_evaluation_committee"
                      :files="research_readiness_defense_evaluation_committee" :master="masterId" />
                  </tab-content> -->
                </b-card>
              </form-wizard>
            </b-tab>
          </b-tabs>
        </div>

        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import MastersController from '@/Controllers/MastersController';
import SettingController from '@/Controllers/SettingController';
import Swal from 'sweetalert2'

// Department
export default {
  components: {
    FormWizard,
    TabContent,
    uploadVue,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      tab: 0,
      items: [],
      load: true,
      steps : {
        step1 : 0,
        step2 : 0
      },
      masterId: Auth.MASTER.id,
      
      research_readiness_defense: { online_session: {} },

    };
  },
  async created() {
    
    this.time = await new SettingController().time();

    const timeLine = new MastersController().timeLine();
    const key = timeLine
      .find((a) => a.code == "second_defense")
      .phases.map((a) => {
        return a.code;
      });

    const res = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|" + key.toString(),
      with: ["mastersData"],
    });
    //Steps Validation
    const master_key_inst = new MasterKeyStatusController();
    const verfy_step_1 = await master_key_inst.verifyStep(
      "upload_the_final_version_of_the_search",
      this.masterId
    )
    this.steps.step1 = verfy_step_1;
    const verfy_step_2 = await master_key_inst.verifyStep(
      "final_supervisor_report",
      this.masterId
    )
    this.steps.step2 = verfy_step_2;
    // End Steps Validation
    this.items = res;
    this.load = false;
    this.upload_the_final_version_of_the_search = this.getData(
      "upload_the_final_version_of_the_search",
      1,
      true
    );
    this.final_supervisor_report = this.getData(
      "final_supervisor_report",
      1,
      true
    );
    this.refer_the_search_to_the_scientific_theft_and_citation_detector_program = this.getData(
      "refer_the_search_to_the_scientific_theft_and_citation_detector_program",
      1,
      true
    );
    this.refer_the_search_to_ensure_compliance_with_the_technical_specifications = this.getData(
      "refer_the_search_to_ensure_compliance_with_the_technical_specifications",
      1,
      true
    );
    this.research_readiness_defense = this.getData(
      "research_readiness_defense",
      1,
      true
    );
    this.research_readiness_defense_evaluation_committee = this.getData(
      "research_readiness_defense_evaluation_committee",
      1,
      true
    );
    this.referral_for_grammar_and_spelling_check = this.getData(
      "referral_for_grammar_and_spelling_check",
      1,
      true
    );

    this.$refs["wizard"].changeTab(0, this.tab);
  },
  methods: {
    setTab(res, key) {
      const find = res.find((a) => a.key == key);
      if (find) return true;
      return false;
    },
    variant(item) {
      return item.value == null || item.value == "" || item.value == "-1";
    },
    // async validateStep(name) {
    //   const refToValidate = this.$refs[name];
    //   console.log(refToValidate);
    //   const returnData = await refToValidate.returnData();
    //   if (!returnData.valid) return false;

    //   return true;
    // },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      if (name == "upload_the_final_version_of_the_search") {

        if (this.steps.step1 == 1) return true;
          return this.swalAlert(name);
      }else if(name == "final_supervisor_report"){
        if (this.steps.step2 == 1) return true;
          return this.swalAlert(name);
      }
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return this.swalAlert(name);

      return true;
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
    swalAlert(name) {
      
        Swal.fire({
        // position: 'top-start',
        icon: 'error',
        title: 'في انتظار الموافقة علي  ',
       text:  this.$t('master.'+name),
        // text:   'master: ' + name,
       

        showConfirmButton: false,
        timer: 3000,
      })
       
    },
  },
};
</script>

<style></style>